import determineStage from "../DetermineStage";
const determineLWPlanningSummary = (initiatives) => {
  const now = new Date();
  const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

  const planningGroups = {
    '<not set>': [],
    'Past due for L5': [],
    'Past due for L4': [],
    'Past due for L3': [],
    'Past due for L2': [],
    'Due soon for L5': [],
    'Due soon for L4': [],
    'Due soon for L3': [],
    'Due soon for L2': [],
    'Not planned (L2 to L4)': [],
    'Not planned (L5)': [],
    'On plan': [],
    Executed: [],
    Cancelled: [],
  };

  initiatives.forEach((initiative) => {
    if (initiative.weeklyStatus === 'Cancelled') {
      planningGroups['Cancelled'].push(initiative);
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const fiveDaysLater = new Date(today);
    fiveDaysLater.setDate(today.getDate() + 5);

    let lwL2Date, lwL3PlanDate, lwL4PlanDate, lwL5PlanDate;
    const history = initiative.history || [];
    // Find relevant history within the last week using Timeline with Stage
    const relevantHistory = (initiative.history || [])
      .filter(
        (entry) =>
          entry &&
          entry.action &&
          (entry.action.includes('Timeline with Stage L2') ||
            entry.action.includes('Timeline with Stage L3') ||
            entry.action.includes('Timeline with Stage L4') ||
            entry.action.includes('Timeline with Stage L5') ||
            entry.action.includes('Timeline with Stage Submitted for L2 Approval') ||
            entry.action.includes('Timeline with Stage Submitted for L3 Approval') ||
            entry.action.includes('Timeline with Stage Submitted for L4 Approval') ||
            entry.action.includes('Timeline with Stage Submitted for L5 Approval'))
      )
      .filter((entry) => new Date(entry.timestamp) <= oneWeekAgo)
      .map((entry) => ({
        action: entry.action,
        timestamp: new Date(entry.timestamp),
        previousValue: entry?.changes ? entry?.changes?.plan?.new : null,
      }));
    if (relevantHistory.length > 0) {
      // Find the latest history entry for each stage
      let latestL2History, latestL3History, latestL4History, latestL5History;

      relevantHistory.forEach((entry) => {
        if (
          entry.action.includes('Timeline with Stage L2') ||
          entry.action.includes('Timeline with Stage Submitted for L2 Approval')
        ) {
          if (!latestL2History || entry.timestamp > latestL2History.timestamp) {
            latestL2History = entry;
          }
        } else if (
          entry.action.includes('Timeline with Stage L3') ||
          entry.action.includes('Timeline with Stage Submitted for L3 Approval')
        ) {
          if (!latestL3History || entry.timestamp > latestL3History.timestamp) {
            latestL3History = entry;
          }
        } else if (
          entry.action.includes('Timeline with Stage L4') ||
          entry.action.includes('Timeline with Stage Submitted for L4 Approval')
        ) {
          if (!latestL4History || entry.timestamp > latestL4History.timestamp) {
            latestL4History = entry;
          }
        } else if (
          entry.action.includes('Timeline with Stage L5') ||
          entry.action.includes('Timeline with Stage Submitted for L5 Approval')
        ) {
          if (!latestL5History || entry.timestamp > latestL5History.timestamp) {
            latestL5History = entry;
          }
        }
      });

      // Use the latest history entries to calculate planning summary
      if (latestL2History && latestL2History.previousValue) {
        try {
          lwL2Date = new Date(latestL2History.previousValue);
        } catch (error) {
          lwL2Date = null;
        }

        if (lwL2Date) {
          if (lwL2Date < today) {
            planningGroups['Past due for L2'].push(initiative);
          } else if (lwL2Date <= fiveDaysLater) {
            planningGroups['Due soon for L2'].push(initiative);
          } else {
            planningGroups['On plan'].push(initiative);
          }
        } else {
          planningGroups['Not planned (L2 to L4)'].push(initiative);
        }
      } else if (latestL3History && latestL3History.previousValue) {
        try {
          lwL3PlanDate = new Date(latestL3History.previousValue);
        } catch (error) {
          lwL3PlanDate = null;
        }

        if (lwL3PlanDate) {
          if (lwL3PlanDate < today) {
            planningGroups['Past due for L3'].push(initiative);
          } else if (lwL3PlanDate <= fiveDaysLater) {
            planningGroups['Due soon for L3'].push(initiative);
          } else {
            planningGroups['On plan'].push(initiative);
          }
        } else {
          planningGroups['Not planned (L2 to L4)'].push(initiative);
        }
      } else if (latestL4History && latestL4History.previousValue) {
        try {
          lwL4PlanDate = new Date(latestL4History.previousValue);
        } catch (error) {
          lwL4PlanDate = null;
        }

        if (lwL4PlanDate) {
          if (lwL4PlanDate < today) {
            planningGroups['Past due for L4'].push(initiative);
          } else if (lwL4PlanDate <= fiveDaysLater) {
            planningGroups['Due soon for L4'].push(initiative);
          } else {
            planningGroups['On plan'].push(initiative);
          }
        } else {
          planningGroups['Not planned (L2 to L4)'].push(initiative);
        }
      } else if (latestL5History && latestL5History.previousValue) {
        try {
          lwL5PlanDate = new Date(latestL5History.previousValue);
        } catch (error) {
          lwL5PlanDate = null;
        }

        if (lwL5PlanDate) {
          if (lwL5PlanDate < today) {
            planningGroups['Past due for L5'].push(initiative);
          } else if (lwL5PlanDate <= fiveDaysLater) {
            planningGroups['Due soon for L5'].push(initiative);
          } else {
            planningGroups['On plan'].push(initiative);
          }
        } else {
          planningGroups['Not planned (L5)'].push(initiative);
        }
      } else {
        planningGroups['<not set>'].push(initiative);
      }
    } else {
      // If no relevant history, use the current stage to calculate planning summary
      const currentStage = determineStage(initiative);
      if (currentStage === 'L1') {
        const L2Entry = initiative.timeline.find((entry) => entry.stage === 'L2');
        if (L2Entry && L2Entry.date && L2Entry.date.plan) {
          lwL2Date = new Date(L2Entry.date.plan);
          if (lwL2Date < today) {
            planningGroups['Past due for L2'].push(initiative);
          } else if (lwL2Date <= fiveDaysLater) {
            planningGroups['Due soon for L2'].push(initiative);
          } else {
            planningGroups['On plan'].push(initiative);
          }
        } else {
          planningGroups['Not planned (L2 to L4)'].push(initiative);
        }
      } else if (currentStage === 'L2') {
        const L3Entry = initiative.timeline.find((entry) => entry.stage === 'L3');
        if (L3Entry && L3Entry.date && L3Entry.date.plan) {
          lwL3PlanDate = new Date(L3Entry.date.plan);
          if (lwL3PlanDate < today) {
            planningGroups['Past due for L3'].push(initiative);
          } else if (lwL3PlanDate <= fiveDaysLater) {
            planningGroups['Due soon for L3'].push(initiative);
          } else {
            planningGroups['On plan'].push(initiative);
          }
        } else {
          planningGroups['Not planned (L2 to L4)'].push(initiative);
        }
      } else if (currentStage === 'L3' || currentStage === 'Submitted for return to L3 approval') {
        const L4Entry = initiative.timeline.find((entry) => entry.stage === 'L4');
        if (L4Entry && L4Entry.date && L4Entry.date.plan) {
          lwL4PlanDate = new Date(L4Entry.date.plan);
          if (lwL4PlanDate < today) {
            planningGroups['Past due for L4'].push(initiative);
          } else if (lwL4PlanDate <= fiveDaysLater) {
            planningGroups['Due soon for L4'].push(initiative);
          } else {
            planningGroups['On plan'].push(initiative);
          }
        } else {
          planningGroups['Not planned (L2 to L4)'].push(initiative);
        }
      } else if (currentStage === 'L4') {
        const L5Entry = initiative.timeline.find((entry) => entry.stage === 'L5');
        if (L5Entry && L5Entry.date && L5Entry.date.plan) {
          lwL5PlanDate = new Date(L5Entry.date.plan);
          if (lwL5PlanDate < today) {
            planningGroups['Past due for L5'].push(initiative);
          } else if (lwL5PlanDate <= fiveDaysLater) {
            planningGroups['Due soon for L5'].push(initiative);
          } else {
            planningGroups['On plan'].push(initiative);
          }
        } else {
          planningGroups['Not planned (L5)'].push(initiative);
        }
      } else if (currentStage === 'L5') {
        planningGroups['Executed'].push(initiative);
      } else if (currentStage === 'L0 (Idea)') {
        planningGroups['<not set>'].push(initiative);
      } else if (currentStage === 'Submitted for L1 approval') {
        planningGroups['<not set>'].push(initiative);
      } else if (currentStage === 'Submitted for L2 approval') {
        planningGroups['<not set>'].push(initiative);
      } else if (currentStage === 'Submitted for L3 approval') {
        planningGroups['<not set>'].push(initiative);
      } else if (currentStage === 'Submitted for L4 approval') {
        planningGroups['<not set>'].push(initiative);
      } else if (currentStage === 'Submitted for L5 approval') {
        planningGroups['<not set>'].push(initiative);
      } else {
        planningGroups['<not set>'].push(initiative);
      }
    }
  });

  return planningGroups;
};
export default determineLWPlanningSummary;
